module.exports = __webpack_public_path__ + "img/ruban_3.9cba7ea3.png";